<template>
  <div>
    <el-dialog
        :title="`${item.title}-商品变动`"
        :visible.sync="dialog"
        top="50px"
        width="98%"
        @close="closeChange"
    >
      <el-row
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          element-loading-spinner="el-icon-loading"
          element-loading-text="请求推送中..请勿刷新网页">
        <el-col :span="4">
          <div style="padding: 10px">
            <el-form id="topicGoodsForm" :model="goodsChangeDto" label-position="top" label-width="80px">
              选品库ID: {{goodsChangeDto.topicId}}
              <el-form-item label="商品名称">
                <el-input v-model="goodsChangeDto.title" placeholder="请输入需要查询的商品名称"></el-input>
              </el-form-item>
              <el-form-item label="商品ID">
                <el-input v-model="goodsChangeDto.goodsId" placeholder="请输入需要查询的商品ID"></el-input>
              </el-form-item>
              <el-form-item label="一级类别">
                <el-select filterable v-model="goodsChangeDto.categoryId1Name" placeholder="请选择" style="width: 100%"
                           @change="getCategory1List">
                  <el-option label="请选择" value="">
                  </el-option>
                  <el-option
                      v-for="(item,index) in categoryId1"
                      :key="index"
                      :label="item.fullName"
                      :value="item.categoryId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级类别">
                <el-select v-model="goodsChangeDto.categoryId2Name" placeholder="请选择" style="width: 100%"
                           @change="queryGetList">
                  <el-option label="请选择" value="">
                  </el-option>
                  <el-option
                      v-for="(item,index) in categoryId2"
                      :key="index"
                      :label="item.fullName"
                      :value="item.categoryId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="全国分销价区间">
                <el-input v-model="goodsChangeDto.minSupplyPrice" placeholder="最小值" style="width: 45%;"></el-input>
                <span style="margin: 0 5px;">~</span>
                <el-input v-model="goodsChangeDto.maxSupplyPrice" placeholder="最大值" style="width: 45%;"></el-input>
              </el-form-item>
              <el-form-item label="折扣区间">
                <el-input v-model="goodsChangeDto.minProfitMargin" placeholder="最小值" style="width: 45%;"></el-input>
                <span style="margin: 0 5px;">~</span>
                <el-input v-model="goodsChangeDto.maxProfitMargin" placeholder="最大值" style="width: 45%;"></el-input>
              </el-form-item>
              <el-form-item label="排序规则">
                <el-select v-model="goodsChangeDto.sortOrder"  multiple clearable placeholder="请选择" style="width: 70%"
                           @change="queryGetList">
                  <el-option label="默认" value=""></el-option>
                  <el-option label="时间降序" value="-1"></el-option>
                  <el-option label="评论数降序" value="1"></el-option>
                  <el-option label="评论数升序" value="2"></el-option>
                  <el-option label="上下架降序(下架在前)" value="3"></el-option>
                  <el-option label="商品变动降序" value="4"></el-option>
                  <el-option label="商品变动升序" value="5"></el-option>
                  <el-option label="成本价降序" value="6"></el-option>
                  <el-option label="成本价升序" value="7"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="评论数最小值">
                <el-input v-model="goodsChangeDto.commentOkCount" placeholder="评论最小值" style="width: 45%;"></el-input>
              </el-form-item>
              <el-form-item label="配送方式">
                <el-select v-model="goodsChangeDto.logisticsType" placeholder="请选择配送方式" style="width: 100%">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="京东" :value="1"></el-option>
                  <el-option label="其他" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-top: 20px">
                <el-button type="primary" @click="queryGetList">筛选</el-button>
                <el-button @click="reset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="20">
          <div style="padding: 10px;">
            <div style="display: flex;justify-content: space-between;width:100%;align-items: center;">
              <div>
                <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bolder fs-3 mb-1">
                商品变动列表
              </span>
                </h3>
              </div>
              <div>
                <label style="font-weight: bold; margin-left: 6px; font-size: 16px;">京东溢价比率：</label>
                <el-input v-model="jdRate" size="small" style="width: 10%"></el-input>
                <label style="font-weight: bold; margin-left: 6px; font-size: 16px;">分销价加价比率：</label>
                <el-input v-model="rate" size="small" style="width: 10%"></el-input>
              </div>
            </div>
            <el-table
                :data="goodsChangeVo"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                :row-class-name="tableRowClassName"
            >
              <el-table-column
                  type="selection"
                  width="30">
              </el-table-column>
              <el-table-column label="商品信息">
                <template slot-scope="scope">
                  <div v-if="scope.row.picUrl.indexOf('/Uploads') ==0">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-50px me-5 demo-image__preview">
                        <img :src="`https://www.1c-1g.cn${scope.row.picUrl}`"
                             alt="" class="">
                        <el-image
                            style="width: 50px; height: 50px"
                            :src="`https://www.1c-1g.cn${scope.row.picUrl}`"
                            :preview-src-list="getSrcList(`https://www.1c-1g.cn${scope.row.picUrl}`)">
                        </el-image>
                      </div>
                      <div class="d-flex justify-content-start flex-column">
                        <a :href="`${scope.row.jdUrl}`"
                           class="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                           target="_blank"
                        >{{ scope.row.title }} <!--@click.prevent="checkClickUrl(scope.row)"--></a>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-50px me-5 demo-image__preview">
                        <!--                      <img :src="scope.row.picUrl">-->
                        <el-image
                            style="width: 50px; height: 50px"
                            :src="scope.row.picUrl"
                            :preview-src-list="getSrcList(scope.row.picUrl)">
                        </el-image>
                      </div>
                      <div
                          class="d-flex justify-content-start flex-column">
                        <a :href="`${scope.row.jdUrl}`"
                           class="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                           target="_blank"
                        >{{ scope.row.title }} <!--@click.prevent="checkClickUrl(scope.row)"--></a>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="分类" width="90px">
                <template slot-scope="scope">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      :content="'入库时间' + String(scope.row.createTime)"
                      placement="top">
                  <span class="text-muted fw-bold text-muted d-block fs-7">
                    {{ scope.row.categoryId1Name ? scope.row.categoryId1Name : "" }}
                    <br>
                    {{ scope.row.categoryId2Name ? scope.row.categoryId2Name : "" }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                  label="来源" width="50">
                <template slot-scope="scope">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      :content="String(scope.row.skuId)"
                      placement="top">
                    <span>{{ scope.row.isJd == 1 ? "京东" : "自营" }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="市场价" width="100">
                <template slot-scope="scope">
                  <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    {{ scope.row.price | format }}
                  </div>
                  加价：
                  <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    {{ scope.row.price * jdRate | format }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="售卖价" width="100">
                <template slot-scope="scope">
                  <el-tooltip
                      effect="dark"
                      content="默认加价比例 1.29477"
                      placement="top">
                    <i class="el-icon-info" style="margin-left: 5px;"></i> <!-- 使用图标提示 -->
                  </el-tooltip>
                  <span class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                  {{ scope.row.supplPrice * rate | format }}
                </span>
                </template>
              </el-table-column>
              <el-table-column label="分销价" width="150">
                <template slot-scope="scope">
                  <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    当时市场价：
                    <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                      {{ scope.row.currentPrice | format }}
                    </div>
                    当时售卖价：
                    <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                      {{ scope.row.currentSupply * rate | format }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  label="折扣"
                  prop="price" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.row.isJd==1">
                    <a v-if="scope.row.supplPrice"
                       class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">{{
                        (scope.row.discount
                            * 10).toFixed(1)
                      }}折</a>
                    <a v-else>-</a>
                  </div>
                  <div v-else>
                    <a v-if="scope.row.supplPrice"
                       class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">{{
                        (((scope.row.poolDisPrice)
                            / scope.row.price) * 10).toFixed(1)
                      }}折</a>
                    <a v-else>-</a>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  label="销售方式"
                  prop="price" width="100">
                <template slot-scope="scope">
                <span v-if="scope.row.lowestBuy == 1 && scope.row.isJd == 1"
                      class="text-muted fw-bold text-muted d-block fs-7">一件代发</span>
                  <span v-else class="text-muted fw-bold text-muted d-block fs-7">
                    集采({{ scope.row.lowestBuy }}个起售)
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="商品状态" width="80">
              <template slot-scope="scope">
                  <span class="text-muted fw-bold text-hover-primary d-block mb-1 fs-6">
                    {{ scope.row.status != 2 ? "上架" : "下架" }}
                  </span>
              </template>
            </el-table-column>
              <el-table-column label="变动状态" width="80">
                <template slot-scope="scope">
                  <span class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    {{ scope.row.changStatus != 2 ? "添加" : "删除" }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="评论" width="90">
                <template slot-scope="scope">
                  <span class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    {{ scope.row.commentOkCount }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="配送" width="90">
                <template slot-scope="scope">
                  <span v-if="scope.row.logisticsType === 1" class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    京东配送
                  </span>
                  <span v-else class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    其他配送
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="变动时间" width="100">
                <template slot-scope="scope">
                  {{ scope.row.changCreateTime | parseTime }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <div>
                    <el-dropdown trigger="click">
                      <el-button size="mini" type="primary">
                        操作 <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item icon="el-icon-money" @click.native="viewPriceTrend(scope.row)">查看价格趋势</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-money" @click.native="reAdd(scope.row)">重新入库</el-dropdown-item>
                        <el-dropdown-item @click.native="editPrice(scope.row)" icon="el-icon-edit">修改市场价</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
              :current-page.sync="goodsChangeDto.current"
              :page-size="goodsChangeDto.size"
              :page-sizes="[10, 30, 50,100,200]"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin-top: 10px;text-align: center"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange">
          </el-pagination>
        </el-col>
      </el-row>
    </el-dialog>

    <EChartsDialog
        :visible.sync="chartDialogVisible"
        :chartData="chartData"
        @chartDialogVisibleFn="chartDialogVisibleFn"
    />
  </div>
</template>
<script>
import {mixins} from "@/views/IDC/components/OnlyGoodsPriceTrend/mixins";

export default {
  mixins: [mixins]
}
</script>
<style>
#topicGoodsForm div label.el-form-item__label {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

#topicGoodsForm .el-form-item {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-table .exit-row {
  background: #f9ebed;
}
</style>